import styled, { keyframes, css } from 'styled-components';

// Animações
const slideUp = keyframes`
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const slideDown = keyframes`
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(100%);
    opacity: 0;
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

const slideRight = keyframes`
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(100%);
  }
`;

const slideLeft = keyframes`
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
`;

// Overlay escuro por trás do menu
export const Overlay = styled.div<{ isClosing?: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  animation: ${props => props.isClosing ? fadeOut : fadeIn} 0.3s ease forwards;
`;

// Container principal do menu fullscreen
export const MenuContainer = styled.div<{ isClosing?: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(180deg, #FFFFFF 0%, #F8F9FA 100%);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  animation: ${props => props.isClosing ? slideDown : slideUp} 0.3s ease forwards;
  overflow: hidden;
`;

// Header do menu
export const MenuHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #E6E6E6;
  background: #FFFFFF;
  min-height: 64px;
`;

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  
  img {
    height: 32px;
    width: auto;
  }
`;

export const CloseButton = styled.button`
  width: 44px;
  height: 44px;
  border: none;
  background: #F6F7F7;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover, &:active {
    background: #E8E8E8;
    transform: scale(1.05);
  }
  
  i {
    font-size: 18px;
    color: #333;
    margin: 0 !important;
  }
`;

export const BackButton = styled.button`
  width: 44px;
  height: 44px;
  border: none;
  background: #F6F7F7;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-right: auto;
  
  &:hover, &:active {
    background: #E8E8E8;
    transform: scale(1.05);
  }
  
  i {
    font-size: 18px;
    color: #333;
    margin: 0 !important;
  }
`;

export const HeaderTitle = styled.h2`
  flex: 1;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0;
`;

// Conteúdo scrollável
export const MenuContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 20px;
  -webkit-overflow-scrolling: touch;
`;

// Grid de categorias
export const CategoryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  padding: 8px 0;
`;

// Card de categoria
export const CategoryCard = styled.div<{ isActive?: boolean }>`
  background: ${props => props.isActive
    ? 'linear-gradient(135deg, #6B4DE6 0%, #8B5CF6 100%)'
    : '#FFFFFF'};
  border: 1px solid ${props => props.isActive ? 'transparent' : '#E6E6E6'};
  border-radius: 16px;
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-height: 120px;
  box-shadow: ${props => props.isActive
    ? '0 4px 12px rgba(107, 77, 230, 0.3)'
    : '0 2px 4px rgba(0, 0, 0, 0.05)'};
  
  &:hover, &:active {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.1);
  }
`;

export const CategoryIcon = styled.div<{ isActive?: boolean }>`
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: ${props => props.isActive
    ? 'rgba(255, 255, 255, 0.2)'
    : 'linear-gradient(135deg, #F0EBFF 0%, #E8E0FF 100%)'};
  display: flex;
  align-items: center;
  justify-content: center;
  
  i {
    font-size: 22px !important;
    color: ${props => props.isActive ? '#FFFFFF' : '#6B4DE6'};
    margin: 0 !important;
  }
`;

export const CategoryName = styled.span<{ isActive?: boolean }>`
  font-size: 14px;
  font-weight: 600;
  color: ${props => props.isActive ? '#FFFFFF' : '#333'};
  text-align: center;
  line-height: 1.3;
`;

export const CategoryBadge = styled.span`
  font-size: 11px;
  color: rgba(255, 255, 255, 0.8);
  background: rgba(255, 255, 255, 0.2);
  padding: 2px 8px;
  border-radius: 10px;
`;

// Submenu
export const SubmenuContainer = styled.div<{ isEntering?: boolean; isLeaving?: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(180deg, #FFFFFF 0%, #F8F9FA 100%);
  display: flex;
  flex-direction: column;
  
  ${props => props.isEntering && css`
    animation: ${slideLeft} 0.3s ease forwards;
  `}
  
  ${props => props.isLeaving && css`
    animation: ${slideRight} 0.3s ease forwards;
  `}
`;

export const SubmenuList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const SubmenuItem = styled.div<{ isActive?: boolean }>`
  display: flex;
  align-items: center;
  padding: 16px 20px;
  background: ${props => props.isActive
    ? 'linear-gradient(135deg, #6B4DE6 0%, #8B5CF6 100%)'
    : '#FFFFFF'};
  border: 1px solid ${props => props.isActive ? 'transparent' : '#E6E6E6'};
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-height: 56px;
  
  &:hover, &:active {
    background: ${props => props.isActive
    ? 'linear-gradient(135deg, #5B3DD6 0%, #7B4CE6 100%)'
    : '#F6F7F7'};
    transform: translateX(4px);
  }
`;

export const SubmenuIcon = styled.div<{ isActive?: boolean }>`
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: ${props => props.isActive
    ? 'rgba(255, 255, 255, 0.2)'
    : '#F0EBFF'};
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  
  i {
    font-size: 16px !important;
    color: ${props => props.isActive ? '#FFFFFF' : '#6B4DE6'};
    margin: 0 !important;
  }
`;

export const SubmenuText = styled.span<{ isActive?: boolean }>`
  flex: 1;
  font-size: 15px;
  font-weight: 500;
  color: ${props => props.isActive ? '#FFFFFF' : '#333'};
`;

export const SubmenuArrow = styled.div<{ isActive?: boolean }>`
  i {
    font-size: 14px !important;
    color: ${props => props.isActive ? '#FFFFFF' : '#999'};
    margin: 0 !important;
  }
`;

// Footer do menu
export const MenuFooter = styled.div`
  display: flex;
  align-items: center;
  padding: 16px 20px;
  border-top: 1px solid #E6E6E6;
  background: #FFFFFF;
  gap: 12px;
`;

export const UserAvatar = styled.div`
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: linear-gradient(135deg, #6B4DE6 0%, #8B5CF6 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FFFFFF;
  font-size: 16px;
  font-weight: 600;
`;

export const UserInfo = styled.div`
  flex: 1;
`;

export const UserName = styled.p`
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin: 0;
`;

export const UserRole = styled.p`
  font-size: 12px;
  color: #999;
  margin: 0;
`;

export const SettingsButton = styled.button`
  width: 44px;
  height: 44px;
  border: none;
  background: #F6F7F7;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover, &:active {
    background: #E8E8E8;
  }
  
  i {
    font-size: 18px;
    color: #666;
    margin: 0 !important;
  }
`;

// Versão do app
export const VersionText = styled.p`
  text-align: center;
  font-size: 11px;
  color: #999;
  padding: 8px;
  margin: 0;
`;

// Botão de logout
export const LogoutButton = styled.button`
  width: 44px;
  height: 44px;
  border: none;
  background: #FEE2E2;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover, &:active {
    background: #FECACA;
    transform: scale(1.05);
  }
  
  i {
    font-size: 18px;
    color: #DC2626;
    margin: 0 !important;
  }
`;
